import React from 'react'
import styled from 'styled-components'

import { Heading2, Heading4 } from '../../styles/Text'

const Heading = styled(Heading2)`
  margin-bottom: 32px;
`

const Subheading = styled(Heading4)`
  margin-bottom: 48px;
`

const Row = styled.div`
  display: flex;
  column-gap: 16px;
  :not(:last-child) {
    margin-bottom: 48px;
  }
`

const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: calc(100% / 3);
  padding: 8px;
  border: 2px solid #e6e2fc;
  border-radius: 4px;
`

const ItemHeading = styled.div`
  margin-bottom: 16px;
  font-weight: 600;
  font-size: 20px;
  line-height: 175%;
`

const Tag = styled.div`
  padding: 6px;
  border: 2px solid transparent;
  border-radius: 4px;
  ${(p) => p.focused && 'border: 2px solid #458FFF; padding: 4px; border-radius: 6px;'}
`

const TagInner = styled.div`
  padding: 4px 8px;
  border-radius: 4px;
  background-color: #f0f1f6;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  ${(p) => p.selected && 'background-color: #6825B1; color: white;'}
  ${(p) => p.pressed && 'background-color: #FF8DE2;'}
`

const Tags = () => {
  return (
    <>
      <Heading>Tags</Heading>
      <Subheading>Primary buttons</Subheading>
      <Row>
        <Item>
          <ItemHeading>Default</ItemHeading>
          <Tag>
            <TagInner>Node.js</TagInner>
          </Tag>
        </Item>
        <Item>
          <ItemHeading>Hover</ItemHeading>
          <Tag>
            <TagInner>Node.js</TagInner>
          </Tag>
        </Item>
        <Item>
          <ItemHeading>Selected</ItemHeading>
          <Tag>
            <TagInner selected>Node.js</TagInner>
          </Tag>
        </Item>
      </Row>
      <Row>
        <Item>
          <ItemHeading>Focussed</ItemHeading>
          <Tag focused>
            <TagInner>Node.js</TagInner>
          </Tag>
        </Item>
        <Item>
          <ItemHeading>Pressed</ItemHeading>
          <Tag>
            <TagInner pressed>Node.js</TagInner>
          </Tag>
        </Item>
        <Item>
          <ItemHeading>Disabled</ItemHeading>
          <Tag>
            <TagInner>Node.js</TagInner>
          </Tag>
        </Item>
      </Row>
    </>
  )
}

export default Tags
